import React from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    reportsContainer: {
      marginTop: '0px',
    },
    statsContainer: {
      background: '#F5F5F5',
      borderRadius: '10px',
      fontSize: '11px',
      padding: '7px 14px',
      textAlign: 'left',
    },
    statsText: {
      fontSize: '11px',
      fontWeight: 'bold',
    },
    typographyOfficialRadiology: {
      fontSize: '12px',
      fontWeight: '600',
      marginBottom: '4px',
      marginTop: '16px',
    },
    typographyRemove: {
      color: '#B12A2A',
      cursor: 'pointer',
      fontSize: '11px',
    },
    uploadActions: {
      marginTop: '4px',
    },
    uploadRadiologyReport: {
      marginTop: '1.25rem',
    },
  };
});

export default ({ fileStatus, onReportChange, onOpenRadiologyReportDialog, onRemoveReport, isSubmitting }) => {
  const classes = useStyles();

  const handleReportChange = (e) => {
    if (onReportChange) onReportChange(e);
  };

  if (!fileStatus.reportUploaded) {
    return (
      <>
        <Button className={classes.uploadRadiologyReport} onClick={onOpenRadiologyReportDialog} fullWidth variant="outlined" component="span" color="primary">
          Upload Radiology Report
        </Button>
      </>
    );
  }

  return (
    <>
      <Typography className={`${classes.typographyOfficialRadiology} text-left`}>
        Official Radiology Report <span style={{ color: '#B12A2A' }}>*</span>
      </Typography>
      <Grid container className={`${classes.reportsContainer} ${classes.statsContainer}`}>
        {fileStatus.uploadedReport.map((file) => (
          <Grid item xs={12}>
            <Typography className={classes.statsText}> {file.name} </Typography>
          </Grid>
        ))}
      </Grid>
      <div className={classes.uploadActions}>
        <input disabled={isSubmitting} onChange={handleReportChange} hidden id="raised-button-report-change" type="file" />
        <span onClick={onRemoveReport} className={classes.typographyRemove} aria-hidden="true">
          Remove
        </span>
      </div>
    </>
  );
};
